import type { Meta } from '../../types/db';

export const meta: Meta = {
  time: '08:14',
  mode: 'Vrij',
  roomId: 'werkkamer',
  connections: { lokaal: true, cloud: true, internet: true },
  cloud: { spent: 1.84, budget: 5, localOnly: false },
  gpu: 'wordt gewekt',
};
